import React, { useState, useEffect } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link, useSearchParams } from 'react-router-dom';
import config from '../config.json';

const NavMenu = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);
  const [searchParams] = useSearchParams();
  const roles = JSON.parse(localStorage.getItem('Roles'));

  const userAccess = {
      hasView: roles?.includes('View') || false,
      hasAdmin: roles?.includes('Admin') || false,
      hasApprover: roles?.includes('Approver') || false,
      hasStandard: roles?.includes('Standard') || false,
      hasReviewer: roles?.includes('Reviewer') || false,
  };

  const { hasView, hasAdmin, hasStandard, hasApprover, hasReviewer } = userAccess;

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  const decodeUserData = () => {
    let encodedUserData = searchParams.get('U');

    if (!encodedUserData) {
      // If 'U' is not in the URL, try to fetch from local storage
      encodedUserData = localStorage.getItem('UserData');
    }

    if (encodedUserData) {
      try {
        // Decode and parse the user data
        const decodedUserData = JSON.parse(atob(encodedUserData));
        setUserData(decodedUserData);
        setAuthenticated(true);
      } catch (error) {
        // Handle decoding error, e.g., invalid base64 data
        console.error('Error decoding user data:', error);
      }
    }
  };

  useEffect(() => {
    decodeUserData();
  }, [searchParams]);

  const handleLogout = () => {
    if (window.confirm("Do you want to logout?") === true) {
      // Clear user data and navigate to the desired path
      window.localStorage.clear();
      setUserData(null);
      setAuthenticated(false);
      window.location.href = `${config.identityUrl}/Identity/Account/Login`; // Replace '/login' with the desired logout path
    }
  };

  const firstname = userData?.Claims?.find((claim) => claim.Type === 'FirstName')?.Value;
  const lastname = userData?.Claims?.find((claim) => claim.Type === 'LastName')?.Value;
  const fullname = `${firstname} ${lastname}`;

  return (
    <header>
      <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
        <div className="d-flex flex-column fs-6">
          <div className="d-flex align-items-center">
            <NavbarBrand tag={Link} to="/">
              <span className="h5">ETR Forms Portal</span>
            </NavbarBrand>
          </div>
          <div className="d-flex align-items-center">
            <Link to="#" className="text-muted me-2" onClick={handleLogout}>
              Logout
            </Link>
            <span className="text-muted me-2">|</span>
            <div className="text-muted">{authenticated && userData && fullname}</div>
          </div>
        </div>

        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
          <ul className="navbar-nav flex-grow">
            {(userAccess.hasAdmin || userAccess.hasStandard) && (
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/employee-list">
                  Employee
                </NavLink>
              </NavItem>
            )}
            {(userAccess.hasView && !userAccess.hasReviewer) && (
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/overtime-list">
                  Overtime
                </NavLink>
              </NavItem>
            )}
            {(userAccess.hasView && !userAccess.hasReviewer) && (<NavItem>
              <NavLink tag={Link} className="text-dark" to="/leave-list">
                Leave
              </NavLink>
            </NavItem>)}
            {(userAccess.hasView && !userAccess.hasReviewer) && (<NavItem>
              <NavLink tag={Link} className="text-dark" to="/undertime-list">
                Undertime
              </NavLink>
            </NavItem>)}
            {(userAccess.hasView && !userAccess.hasReviewer) && (<NavItem>
              <NavLink tag={Link} className="text-dark" to="/timeentry-list">
                Time Entries
              </NavLink>
            </NavItem>)}
            {(userAccess.hasAdmin || userAccess.hasReviewer) && (
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/reportviews">
                  Report View
                </NavLink>
              </NavItem>
            )}
            {userAccess.hasAdmin && (
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/user-list">
                  Users
                </NavLink>
              </NavItem>
            )}
          </ul>
        </Collapse>
      </Navbar>
    </header>
  );
};

export default NavMenu;
